__turbopack_context__.v({
  "active": "FqJLXG_active",
  "continueButton": "FqJLXG_continueButton",
  "dateTimeSection": "FqJLXG_dateTimeSection",
  "header": "FqJLXG_header",
  "heatApp": "FqJLXG_heatApp",
  "infoText": "FqJLXG_infoText",
  "modal": "FqJLXG_modal",
  "orderTimeSwitch": "FqJLXG_orderTimeSwitch",
  "schedulePreOrderTitle": "FqJLXG_schedulePreOrderTitle",
  "whiteLabeled": "FqJLXG_whiteLabeled",
  "wrapper": "FqJLXG_wrapper",
});
